"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerAdditionalSupportPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var operators_1 = require("rxjs/operators");
var VulnerableCustomerAdditionalSupportModal_1 = require("../../components/modals/VulnerableCustomerAdditionalSupportModal");
var Confirmation_1 = require("../Confirmation");
var react_router_dom_1 = require("react-router-dom");
var VulnerableCustomerAction_1 = require("../../model/VulnerableCustomerAction");
var VulnerableCustomerAdditionalSupportPagePlain = /** @class */ (function (_super) {
    __extends(VulnerableCustomerAdditionalSupportPagePlain, _super);
    function VulnerableCustomerAdditionalSupportPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.renderRemoveAdditionalSupportConfirmation = function () {
            var _a, _b;
            var message;
            if (((_a = _this.state.additionalSupportRecord) === null || _a === void 0 ? void 0 : _a.appliedAction) && _this.isStoppableAction()) {
                message = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Removing this additional support record for policy: ", _this.props.params.policyNumber, " ", (0, jsx_runtime_1.jsxs)("strong", { children: ["will also stop the current vulnerable customer action: ", VulnerableCustomerAction_1.VulnerableCustomerActionHelper.getActionText((_b = _this.state.additionalSupportRecord) === null || _b === void 0 ? void 0 : _b.appliedAction)] })] });
            }
            else {
                message = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to remove additional support record for policy: ", _this.props.params.policyNumber, "?"] });
            }
            return ((0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: _this.state.showRemoveAdditionalSupportRecordConfirmation, hide: function () { return _this.setState({ showRemoveAdditionalSupportRecordConfirmation: false }); }, confirm: _this.removeAdditionalSupportRecord, title: "Vulnerable Customer additional support confirmation", message: message }));
        };
        _this.renderAdditionalSupportPopup = function () {
            return ((0, jsx_runtime_1.jsx)(VulnerableCustomerAdditionalSupportModal_1.default, { policyNumber: _this.props.params.policyNumber, record: _this.state.additionalSupportRecord, customerReferenceNumber: _this.props.params.customerId, newAdditionalSupport: false, isOpen: _this.state.showAdditionalSupportEditRecordPopup, onClose: function () { return _this.setState({ showAdditionalSupportEditRecordPopup: false }); }, onSuccess: function (record) {
                    var _a;
                    _this.supportPortalService.logAgentActivity(_this.props.params.id, { "action": "Edit VC additional support", "customer": _this.props.params.policyNumber, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
                    _this.setState({
                        showAdditionalSupportEditRecordPopup: false,
                        additionalSupportRecord: record
                    });
                } }));
        };
        _this.editAdditionalSupportRecord = function () {
            _this.setState({
                showAdditionalSupportEditRecordPopup: true
            });
        };
        _this.showRemoveAdditionalSupportRecordConfirmation = function () {
            _this.setState({
                showRemoveAdditionalSupportRecordConfirmation: true
            });
        };
        _this.removeAdditionalSupportRecord = function () {
            _this.supportPortalService.deactivateAdditionalSupportRecord(_this.state.additionalSupportRecord.referenceNumber)
                .subscribe(function () {
                if (_this.isStoppableAction()) {
                    _this.supportPortalService.cancelVulnerableCustomerAction(_this.props.params.id, _this.props.params.policyNumber, _this.state.additionalSupportRecord.appliedAction)
                        .subscribe(function () {
                        var _a;
                        _this.supportPortalService.logAgentActivity(_this.props.params.id, { "action": "Edit customer details", "customer": _this.props.params.policyNumber, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
                        _this.setState({
                            additionalSupportRecord: undefined,
                            redirectToCustomerPage: true
                        });
                    });
                }
                else {
                    _this.setState({
                        additionalSupportRecord: undefined,
                        redirectToCustomerPage: true
                    });
                }
            });
        };
        _this.isStoppableAction = function () {
            return (_this.state.additionalSupportRecord.appliedAction === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.CANCEL_FUTURE_INTEREST ||
                _this.state.additionalSupportRecord.appliedAction === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.STOP_FUTURE_CANCELLATION_FEES ||
                _this.state.additionalSupportRecord.appliedAction === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY ||
                _this.state.additionalSupportRecord.appliedAction === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.SUSPEND_INTEREST);
        };
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState({
                loadingQueueSize: _this.state.loadingQueueSize + 1
            }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState({
                loadingQueueSize: _this.state.loadingQueueSize - 1
            }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0 && !_this.state.additionalSupportRecord;
        };
        _this.state = {
            loadingQueueSize: 0,
            showAdditionalSupportEditRecordPopup: false,
            showRemoveAdditionalSupportRecordConfirmation: false,
            redirectToCustomerPage: false
        };
        return _this;
    }
    VulnerableCustomerAdditionalSupportPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.logAgentActivity(this.props.params.id, { "action": "No Action", "customer": this.props.params.policyNumber }).subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService.getActiveAdditionalSupportRecord(_this.props.params.policyNumber)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (record) {
                _this.setState({
                    additionalSupportRecord: record
                });
            });
        });
    };
    VulnerableCustomerAdditionalSupportPagePlain.prototype.render = function () {
        document.title = "Vulnerable customer additional support";
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: !this.loading }), this.templates.renderHeader(), this.templates.renderBackLink("Back to customer selection", true, "/customers/".concat(this.props.params.id)), (0, jsx_runtime_1.jsxs)("div", { className: "vc-additional-support-panel", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-white", children: "Edit additional support" }), (0, jsx_runtime_1.jsx)("div", { className: "row panel-border", children: (0, jsx_runtime_1.jsxs)("div", { className: "col-12 my-3 pl-5 pr-5", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold mb-3", children: "Additional support" }), this.state.additionalSupportRecord ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Category: " }), this.state.additionalSupportRecord.category] }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Status: " }), this.state.additionalSupportRecord.status] }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Description: " }), this.state.additionalSupportRecord.description] }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-4", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Action: " }), VulnerableCustomerAction_1.VulnerableCustomerActionHelper.getActionText(this.state.additionalSupportRecord.appliedAction)] })] }) :
                                        (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-bold mb-4", children: ["No records found for policy: ", this.props.params.policyNumber] }), (0, jsx_runtime_1.jsxs)("div", { className: "action-buttons", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { role: "button", className: "link-edit", onClick: this.editAdditionalSupportRecord, children: "Edit" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { role: "button", className: "link-remove", onClick: this.showRemoveAdditionalSupportRecordConfirmation, children: "\u2013 Remove" }) })] })] }) })] }), this.renderRemoveAdditionalSupportConfirmation(), this.state.additionalSupportRecord && this.renderAdditionalSupportPopup(), this.state.redirectToCustomerPage && (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/customers/".concat(this.props.params.id) }), this.templates.renderFooter()] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], VulnerableCustomerAdditionalSupportPagePlain.prototype, "supportPortalService", void 0);
    VulnerableCustomerAdditionalSupportPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VulnerableCustomerAdditionalSupportPagePlain);
    return VulnerableCustomerAdditionalSupportPagePlain;
}(React.Component));
exports.VulnerableCustomerAdditionalSupportPagePlain = VulnerableCustomerAdditionalSupportPagePlain;
exports.default = (0, components_1.withRouter)(VulnerableCustomerAdditionalSupportPagePlain);
//# sourceMappingURL=VulnerableCustomerAdditionalSupportPage.js.map